import React from 'react';
import { X } from 'lucide-react';

const AddEmployeeModal = ({
  isModalOpen,
  isEdit,
  onSubmit,
  handleSubmit,
  setIsModalOpen,
  register,
  setValue,
  reset,
  currentPicture,
}) => {
  return (
    <div className={`modal ${isModalOpen ? 'block' : 'hidden'} fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center`}>
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{isEdit ? 'Edit Employee' : 'Add Employee'}</h2>
          <button onClick={() => setIsModalOpen(false)}>
            <X className="h-6 w-6" />
          </button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium">First Name</label>
              <input {...register('firstName')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Last Name</label>
              <input {...register('lastName')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Father Name</label>
              <input {...register('fatherName')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Gender</label>
              <select {...register('gender')} className="mt-1 p-2 border rounded w-full">
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Marital Status</label>
              <select {...register('maritalStatus')} className="mt-1 p-2 border rounded w-full">
                <option value="">Select</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Email</label>
              <input {...register('email')} className="mt-1 p-2 border rounded w-full" disabled={isEdit} />
            </div>
            <div>
              <label className="block text-sm font-medium">Phone</label>
              <input {...register('phone')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Location</label>
              <input {...register('location')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">CNIC</label>
              <input {...register('cnic')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">DOB</label>
              <input type="date" {...register('dob')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Emergency Contact</label>
              <input {...register('emergencyContact')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Contact Relationship</label>
              <input {...register('contactRelationShip')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Address</label>
              <input {...register('address')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Religion</label>
              <input {...register('religion')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Department</label>
              <input {...register('department')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Designation</label>
              <input {...register('designation')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">Profile Picture</label>
              <input
                type="file"
                onChange={(e) => setValue('profilePicture', e.target.files[0])}
                className="mt-1 p-2 border rounded w-full"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Active</label>
              <input type="checkbox" {...register('isActive')} className="mt-1" />
            </div>
            <div>
              <label className="block text-sm font-medium">User Role</label>
              <input {...register('userRole')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">User Type</label>
              <input {...register('userType')} className="mt-1 p-2 border rounded w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium">User Status</label>
              <input {...register('userStatus')} className="mt-1 p-2 border rounded w-full" />
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              type="button"
              onClick={() => {
                reset();
                setIsModalOpen(false);
              }}
              className="px-4 py-2 bg-gray-300 rounded"
            >
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-[#241763] text-white rounded">
              {isEdit ? 'Update' : 'Add'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployeeModal;